import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import Jessibuca from 'jessibuca-js';

@Component({
  selector: 'nc-video-flv',
  templateUrl: './video-flv.component.html',
  styleUrls: ['./video-flv.component.less']
})
export class VideoFlvComponent implements AfterViewInit, OnDestroy {
  @ViewChild('videoContainer') videoContainer!: ElementRef<HTMLInputElement>;
  private jessibuca!: Jessibuca;
  playError: boolean = false;
  videoUrl: string = '';
  @Input() set ncUrl(value: string) {
    this.videoUrl = value;
    setTimeout(() => {
      //加延迟，防止其他传入参数未获取到
      this.init();
    })
  };
  @Output() ncLoaded = new EventEmitter<Jessibuca>();//返回Jessibuca
  @Output() ncPlaying = new EventEmitter<boolean>();//返回播放状态

  //静音
  @Input() set ncMuted(value: boolean | string) {
    this.mutedMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //自动播放
  @Input() set ncAutoplay(value: boolean | string) {
    this.autoplayMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //铺满
  @Input() set ncFill(value: boolean | string) {
    this.fillMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //截图
  @Input() set ncScreenshot(value: boolean | string) {
    this.screenshotMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //录屏
  @Input() set ncRecord(value: boolean | string) {
    this.recordMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //网速
  @Input() set ncBandwidth(value: boolean | string) {
    this.bandwidthMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  //隐藏控制栏
  @Input() set ncControls(value: boolean | string) {
    this.controlsMode = value !== null && value !== undefined && value !== false && value !== 'false';
  }

  mutedMode: boolean = true;
  autoplayMode: boolean = false;
  fillMode: boolean = false;
  screenshotMode: boolean = false;
  recordMode: boolean = false;
  bandwidthMode: boolean = false;
  controlsMode: boolean = true;

  constructor() { }

  ngOnDestroy(): void {
    this.destroy();
  }

  ngAfterViewInit(): void {
  }

  init() {
    this.destroy();
    this.jessibuca = new Jessibuca({
      url: this.videoUrl,
      decoder: 'assets/jessibuca-js/decoder.js',
      container: this.videoContainer.nativeElement,
      videoBuffer: 0.2,//缓存时长
      isResize: !this.fillMode,//false:视频画面完全填充canvas区域,画面会被拉伸;true:视频画面做等比缩放后,高或宽对齐canvas区域,画面不被拉伸,但有黑边
      loadingText: '加载中',//加载过程中文案
      debug: false,
      timeout: 8,
      showBandwidth: this.bandwidthMode,//显示网速
      operateBtns: {
        fullscreen: true,//全屏按钮
        screenshot: this.screenshotMode,//截图按钮
        play: true,//播放暂停按钮
        audio: true,//声音按钮
        record: this.recordMode//录制按钮
      },
      isNotMute: false,//是否开启声音
      controlAutoHide: true//自动隐藏控制栏
    });

    if (!this.controlsMode) {
      const controls = this.videoContainer.nativeElement.querySelector('.jessibuca-controls');
      controls?.remove();
    }

    //错误监听
    this.jessibuca.on("error", (error) => {
      console.error('error:', error);
      this.playError = true;
    })

    //超时监听
    this.jessibuca.on("timeout", (error) => {
      console.error('timeout:', error);
      this.playError = true;
    })

    //播放监听
    this.jessibuca.on("play", () => {
      this.ncPlaying.emit(true);
    });

    //暂停监听
    this.jessibuca.on("pause", () => {
      this.ncPlaying.emit(false);
    });

    this.jessibuca.on("load", () => {
      //自动播放
      if (this.autoplayMode) {
        this.jessibuca.play();
      }
      //开启声音
      if (!this.mutedMode) {
        this.jessibuca.cancelMute();
      }
      //返回对象
      this.ncLoaded.emit(this.jessibuca);
    });
  }

  destroy() {
    if (this.jessibuca) {
      this.jessibuca.destroy();
    }
  }
}
